import { defineComponent as l, computed as n, openBlock as o, createElementBlock as m, normalizeClass as i, toDisplayString as p } from "vue";
import { SfBadgePlacement as s, SfBadgeVariant as c } from "@storefront-ui/shared";
const g = /* @__PURE__ */ l({
  __name: "SfBadge",
  props: {
    content: {
      type: [String, Number],
      default: ""
    },
    max: {
      type: Number,
      default: 99
    },
    placement: {
      type: String,
      default: s["top-right"]
    },
    variant: {
      type: String,
      default: c.standard
    }
  },
  setup(e) {
    const t = e, a = n(() => t.variant === "dot"), r = n(() => a.value ? "" : !Number.isNaN(t.content) && Number(t.content) > t.max ? `${t.max}+` : t.content);
    return (u, d) => (o(), m("span", {
      class: i([
        "block absolute py-0.5 px-1 bg-secondary-700 font-medium text-white text-[8px] leading-[8px] rounded-xl",
        {
          "min-w-[12px] min-h-[12px]": !a.value,
          "w-[10px] h-[10px]": a.value,
          "top-0 right-0 -translate-x-0.5 translate-y-0.5": e.placement === "top-right",
          "top-0 left-0 translate-x-0.5 translate-y-0.5": e.placement === "top-left",
          "bottom-0 right-0 -translate-x-0.5 -translate-y-0.5": e.placement === "bottom-right",
          "bottom-0 left-0 translate-x-0.5 -translate-y-0.5": e.placement === "bottom-left"
        }
      ]),
      "data-testid": "badge"
    }, p(r.value), 3));
  }
});
export {
  g as default
};
